import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/alert-dialog';
import {
  toastError,
  toastSuccess,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/toast';
import service from '../../service';
import { useQueryClient } from '@tanstack/react-query';
import { Trash } from 'lucide-react';

const UserRoleDialog = ({ data }) => {
  const query = useQueryClient();

  const resetTable = () => {
    query.invalidateQueries({ queryKey: ['userRoles'] });
  };

  const handleDelete = async () => {
    const deletedRole = await service.deleteUserRole(data.id);
    if (deletedRole) {
      toastSuccess(`Delete User Role - successful!`);
      resetTable();
    } else {
      toastError(`Unable to delete User Role`);
    }
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            icon={{
              src: <Trash />,
            }}
            className="text-red-600"
          >
            Delete User Role
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete</AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to delete the following role?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <p className="text-center text-sm">{data.name}</p>
          <AlertDialogFooter>
            <AlertDialogCancel asChild>
              <Button variant="outline">Close</Button>
            </AlertDialogCancel>
            <AlertDialogAction asChild>
              <Button variant="destructive" onClick={handleDelete}>
                Confirm
              </Button>
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default UserRoleDialog;
